import React from 'react';
import { GridToolbarContainer, GridToolbarDensitySelector, GridToolbarQuickFilter } from '@mui/x-data-grid';

export function WordMappingCustomToolbar(): JSX.Element {
  return (
    <GridToolbarContainer>
      <div className="project-grid-toolbar-title">Word Mapping</div>

      <div className="project-grid-toolbar-filters">
        <GridToolbarQuickFilter />
        <GridToolbarDensitySelector />
      </div>
    </GridToolbarContainer>
);
}
